import ApiService from './api.service'

const RolesService = {
	getRoles: function () {
		return ApiService.get('/role/list');
	},
	deleteRole: function (id) {
		return ApiService.delete(`/role/delete/${id}`);
	},
	editRole: function (newRole) {
		return ApiService.post(`/role/edit/${newRole.id}`, newRole);
	},
	createRole: function (newRole) {
		return ApiService.post('/role/create', newRole);
	},
	permListData(roleId) {
		return ApiService.post(`/role/permissions/${roleId}`)
	},
	saveRolePermissionsApi: function (payloadArray) {
		return ApiService.put(`/role/add-permissions/${payloadArray.id}`, payloadArray.selectedArray)
	}

};

export default RolesService
